// extracted by mini-css-extract-plugin
export var wrapperStyle = "hero_promo_card-module--wrapperStyle--cDxw1";